import { ActionFilters, BigButton, GlobalFilter, SharePopup, TopButtonArea } from '../common';
import { Breadcrumbs, CommonGrid, TopContainer } from '../layouts';
import {
  COMMON_TAGS_MODEL_TYPES,
  FILTER_BY_DELETE_OPTIONS_LIST,
  FILTER_BY_OPTIONS_LIST,
  MODEL_TYPES,
} from '../constants/constants';
import { GlobalDefaultTeamMemberFilter, GlobalSearchTagsFilter } from '../common/GlobalFilter';
import {
  My3dModelDetailsPopup,
  My3dModelDetailsPopupController,
} from '../common/My3dModelDetailsPopup/My3dModelDetailsPopup';
import React, { useEffect, useMemo, useState } from 'react';
import {
  curatorActions,
  selectedIsImageScanSearchFile,
  selectedIsImageScanSearchOpen,
} from '../redux/slicers/admin/curatorSlicer';
import { useDispatch, useSelector } from 'react-redux';

import AddToCollectionPopup from '../common/AddToCollectionPopup';
import CollectionIcon from '../components/icons/CollectionIcon';
import FilterSideModalButton from '../common/FilterSideModalButton';
import FooterOptions from '../layouts/FooterOptions';
import { ImageScanSearchModal } from '../components/ImageScanSearch/ImageScanSearchModal';
import InfiniteScroll from '../components/InfiniteScroll/InfiniteScroll';
import { PageSearchBar } from '../common/UniversalSearchForm/UniversalSearchForm';
import PageTitle from '../common/PageTitle';
import { PropDetailsPopup } from '../common/PropDetailsPopup/PropDetailsPopup';
import { PropsEditDetailsPopupController } from '../common/PropDetailsPopup/EditPropDetailsPopup';
import { SearchFromScannedImage } from '../components/ImageScanSearch/SearchFromScannedImage';
import { ThumbnailContainerV2 } from '../common/ThumbnailContainerV2';
import TopContainerV2 from '../layouts/TopContainerV2';
import _ from 'lodash';
import { paginatedProductActions } from '../redux/slicers/admin/paginatedProductSlicer';
import { addOneMonthAddCurrentYear, totalItemCount } from '../helpers/jsHelper';
import { usePageTitle } from '../hooks/usePageTitle';
import { usePropSearchByImage } from '../hooks/usePropSearchByImage';
import { useProps } from '../hooks/useProps';
import { useScreenSettings } from '../helpers/configureHelper';
import { addUpdateParamsInSequence } from '../redux/slicers/filters/filterSlicer';
import { getParamsFromFilterBy } from '../helpers/urlHelper';
import { RestoreIcon } from '../components/icons/RestoreIcon';
import {
  apiArchivePropsGroup,
  apiGetPropOptimized,
  apiModelAdminDelete,
  apiModelDeleteAndRestore,
} from '../helpers/api';
import { errorToast, successToast, warningToast } from '../helpers/toastHelper';
import { useUserContext } from '../contexts/UserContext';
import { useSearchParams } from 'react-router-dom';
import { useInfoDialogaActions } from '../hooks/useInfoDialogaActions';
import { useSwitchToOrganization } from '../hooks/useSwitchToOrganization';
import {
  NotFound3DModalUI,
  Upload3DModalButton,
} from '../components/3DModelUpload/Upload3DModalButton';
import { TrashV2Icon, WarningContentInfoIcon } from '../assets/icons';
import { isAdminOrOwner } from '../helpers/userHelper';
import useCurrentOrganizationInfo from '../hooks/useCurrentOrganizationInfo';
import { GenerateContentModal } from '../components/popups/GenerateContentModal';
import PaymentDoneIcon from '../components/icons/PaymentDone';
import NoDataContainer from '../common/NoDataContainer.js/NoDataContainer';
import { model3dDetailsActions } from '../redux/slicers/model3dDetailsSlicer';
import ContentGeneration from './NewProductUIV2/ContentGeneration/ContentGeneration';

export const EDIT_TYPE = {
  PRODUCT: 'PRODUCT',
  MODEL_3D: 'MODEL_3D',
};

export default function MyProps({
  title = 'Props',
  pageTitle = 'Props',
  cardType = 'props',
  breadcrumbs,
  apiConfig = {},
  modelType = MODEL_TYPES.PRODUCT,
  noDataText = 'No data found',
  useGlobalSearch,
  cardProps,
  designV2,
  hideStickyHeader = null,
  subClassName = null,
}) {
  const dispatch = useDispatch();
  const pageSettings = useScreenSettings(cardType);
  const { sortOptions, showTeamMemberFilter, defaultSortOption } = pageSettings;
  usePageTitle(pageTitle);
  const imageScanSearchOpen = useSelector(selectedIsImageScanSearchOpen);
  const imageSearchFile = useSelector(selectedIsImageScanSearchFile);
  const toggleImageScanSearchOpen = () => dispatch(curatorActions.toggleImageScanSearchOpen());
  const [height, setHeight] = useState('100%');
  const { currentUser, isGuestLogin, isGuestUser } = useUserContext();
  const { isFreemiumOrSelfServeUser } = useCurrentOrganizationInfo();
  const [requestParams, setRequestParams] = useState({
    is_guest_user: isGuestUser(),
    is_mattress_builder_prop_removed: true,
  }); // ({ is_user_model_uploaded: false });
  const currentOrg = currentUser?.organization;
  const { defaultBrands, defaultCreatedBy } = apiConfig;
  const [searchParams, setSearchParams] = useSearchParams();
  const organization = searchParams.get('organization');
  const { openInfoDialog, closeInfoDialog } = useInfoDialogaActions();
  const { switchToOrganization } = useSwitchToOrganization();
  const modelId = searchParams.get('model_id');
  
  useEffect(() => {
    if (modelId) {
      dispatch(model3dDetailsActions.show({ id: modelId }));
    }
  }, [modelId]);

  const switchOrganization = () => {
    switchToOrganization(parseInt(organization), {
      onSuccess: () => {
        successToast('Organization changed!');
        closeInfoDialog();
      },
    });
  };

  const useDataHooks = useMemo(() => {
    return imageSearchFile ? usePropSearchByImage : useProps;
  }, [imageSearchFile]);

  useEffect(() => {
    if (modelType === MODEL_TYPES.THREEDMODELS) {
      if (organization && currentOrg.toString() !== organization.toString()) {
        openInfoDialog({
          onClose: closeInfoDialog,
          title: 'Organization mismatch!',
          description:
            'The created 3D model belongs to a different organization. Do you want to switch your organization?',
          buttonText: 'Switch',
          cancelButtonText: 'Cancel',
          onCancelClick: () => closeInfoDialog(),
          onButtonClick: () => switchOrganization(),
        });

        return;
      }
    }
  }, [modelType]);

  const {
    list,
    loading,
    fetchMoreData,
    hasMore,
    total,
    hasData,

    selected,
    anySelected,
    allSelected,
    selectedList,
    sortBy,
    filterBy,
    onSortChange,
    toggleAll,
    toggleItem,
    resetSelection,
    addToCollection,
    search,
    onSearchChange,
    refetchList,
    onFilterByChange,
  } = useDataHooks({
    defaultSort: defaultSortOption,
    defaultBrands,
    defaultCreatedBy,
    useGlobalSearch,
    modelType,
    useOptimizedAPI: true,
    requestParams,
  });
  const isModalPage = modelType === MODEL_TYPES.THREEDMODELS;

  const handleUpdateModelSuccess = (id, { name }) => {
    dispatch(paginatedProductActions.update({ id, name }));
  };
  const handleProductUpdate = (data) => {
    dispatch(paginatedProductActions.update(data));
  };

  const getImageSearchContainerHeight = () => {
    let _height = window.innerHeight - 165;
    if (window.innerWidth < 1025) {
      _height = '100%';
    } else if (window.innerWidth > 1025 && window.innerWidth <= 1300) {
      _height = window.innerHeight;
    }
    // else if (window.innerWidth >= 1301 && window.innerWidth < 1541) {
    //   // _height = window.innerHeight - 215;
    // }
    setHeight(_height);
    return _height;
  };

  useEffect(() => {
    return () => dispatch(curatorActions.setImageScanSearchFile(null));
  }, []);

  useEffect(() => {
    if (!imageSearchFile) return;
    getImageSearchContainerHeight();
    window.addEventListener('resize', getImageSearchContainerHeight);
    return () => window.removeEventListener('resize', getImageSearchContainerHeight);
  }, [imageSearchFile]);

  // const _noDataText = search ? `You don't have any ${cardType} with "${search}" name.` : noDataText;
  const _noDataText = search ? (
    `You don't have any ${cardType} with "${search}" name.`
  ) : (
    <NotFound3DModalUI onSuccess={refetchList} message={noDataText} />
  );

  const handleFilterByChange = (value) => {
    dispatch(addUpdateParamsInSequence({ filterBy: getParamsFromFilterBy(value) }));
    onFilterByChange(value);
  };

  const handleRestore = async () => {
    selectedList?.map(async (list, index) => {
      if (!list?.id) return;
      const payload = {
        is_archived: false,
      };
      const res = await apiArchivePropsGroup(list?.id, payload);
      if (res?.status && index === selectedList?.length - 1) {
        successToast(res?.message || 'Products group restored successfully.');
        refetchList && refetchList?.();
      }
    });
  };

  const topButtonList = [
    {
      element: BigButton,
      bigBtnClass: 'lf-btn-2',
      iconBefore: <CollectionIcon />,
      buttonTitle: 'Add To Collection',
      onClick: addToCollection,
    },
    {
      element: SharePopup,
      bigBtnClass: 'lf-btn-2',
      bigButton: true,
      selectedList,
      modelType: 1,
    },
  ];

  const handleDelete = (data) => {
    let deleteItem = data;
    const restrictedItem = !isAdminOrOwner(currentUser)
      ? data?.filter(({ member_details }) => member_details?.member_id !== currentUser.id)
      : [];
    if (!isAdminOrOwner(currentUser) && restrictedItem?.length) {
      deleteItem = data?.filter(
        ({ member_details }) => member_details?.member_id === currentUser.id
      );
      if (!deleteItem?.length) {
        warningToast('You do not have ownership to delete this item.');
        return;
      }
    }
    const hasInactiveItem = deleteItem.some(
      ({ is_customer_product_expired }) => is_customer_product_expired
    );
    const isSingleDelete = deleteItem?.length === 1;
    // const date =
    //   isSingleDelete && deleteItem?.[0]?.delete_expired_date
    //     ? addOneMonthAddCurrentYear(deleteItem?.[0]?.delete_expired_date)
    //     : null;
    const date = null;

    const handleSuccessMessage = (restrictedItem) => {
      const message = restrictedItem?.length
        ? "Some items were not deleted because you don't have the necessary ownership permissions to delete them."
        : '';
      openInfoDialog({
        topIcon: <PaymentDoneIcon />,
        title: 'Your delete request has been submitted.',
        description: date ? (
          <>
            {`All the items (projects, props, renders, etc.) using this model will no longer be accessible after`}{' '}
            <strong>
              <b>{date}</b>
            </strong>
            .
          </>
        ) : (
          `All items (projects, props, renders, etc.) using ${
            isSingleDelete ? 'this model' : 'these models'
          } will no longer be accessible after their respective deletion dates.`
        ),
        secondLineDescription: message,
        titleStyle: { textAlign: 'start' },
        buttonText: 'Okay',
        size: 'lg',
        onButtonClick: () => closeInfoDialog(),
      });
    };
    openInfoDialog({
      topIcon: <WarningContentInfoIcon />,
      title: isSingleDelete
        ? 'Are you sure you want to delete this model?'
        : 'Are you sure you want to proceed with these models?',
      description: (
        <>
          {hasInactiveItem && (
            <p>
              {`You have selected some inactive models. These models will be deleted permanently. This action cannot be undone.`}
            </p>
          )}
          {date ? (
            <>
              {`This model maybe linked to certain items (projects, props, renders, etc.). You won’t be able to access these items after`}{' '}
              <strong>
                <b>{date}</b>
              </strong>
              .
            </>
          ) : (
            <>
              <p>
                {`The selected model${
                  isSingleDelete ? '' : 's'
                } may be linked to certain items(projects, props, renders,
                    etc). After the respective subscription period ends, you will no longer have
                    access to these linked items.`}
              </p>

              <p>
                {`To retain access, you can restore ${
                  isSingleDelete ? 'this model' : 'these models'
                }  before the respective subscription
                    period ends.`}
              </p>
            </>
          )}
        </>
      ),
      secondLineDescription:
        date && isSingleDelete
          ? `You can restore the model before this date to retain access.`
          : '',
      titleStyle: { textAlign: 'start' },
      cancelButtonText: 'Cancel',
      buttonText: 'Confirm',
      size: 'lg',
      onButtonClick: async () => {
        const formData = new FormData();
        formData.append('is_delete_on_expire', true);
        formData.append('product_ids', deleteItem?.map(({ id }) => id)?.join(','));

        await apiModelDeleteAndRestore(
          formData
          // `Your ${deleteItem?.length > 1 ? 'models' : 'model'} deleted successfully`
        )
          .then((res) => {
            refetchList?.();
            handleSuccessMessage(restrictedItem);
          })
          .catch((error) => {});
      },
    });
  };

  const handleDeleteGuestUser = (data) => {
    let deleteItem = data;
    deleteItem = deleteItem.filter((val) => val?.owner_organization === currentUser?.organization);
    const isSingleDelete = deleteItem?.length === 1;
    if (!deleteItem?.length) return;
    openInfoDialog({
      topIcon: <WarningContentInfoIcon />,
      title: isSingleDelete
        ? 'Are you sure you want to delete this model?'
        : 'Are you sure you want to proceed with these models?',
      description: (
        <p>
          {`The selected model${
            isSingleDelete ? '' : 's'
          } may be linked to certain items(projects, props, renders,
              etc)`}
        </p>
      ),
      titleStyle: { textAlign: 'start' },
      cancelButtonText: 'Cancel',
      buttonText: 'Confirm',
      size: 'lg',
      onButtonClick: async () => {
        const formData = new FormData();
        deleteItem?.map(({ id }) => {
          formData.append('id', id);
        });
        await apiModelAdminDelete(formData).then((res) => {
          if (res?.status) {
            refetchList?.();
            successToast(res?.message || `Your model${isSingleDelete ? '' : 's'} deleted successfully`);
          } else {
            errorToast(res?.message || 'Something went wrong. Please try again.');
          }
        });
      },
    });
  };

  const handleRestoreModal = (data) => {
    let deleteItem = data;
    const restrictedItem = !isAdminOrOwner(currentUser)
      ? data?.filter(({ member_details }) => member_details?.member_id !== currentUser.id)
      : [];
    if (!isAdminOrOwner(currentUser) && restrictedItem?.length) {
      deleteItem = data?.filter(
        ({ member_details }) => member_details?.member_id === currentUser.id
      );
      if (!deleteItem?.length) {
        warningToast('You do not have ownership to restore this item.');
        return;
      }
    }
    const message = restrictedItem?.length
      ? "Some items were not restored because you don't have the necessary ownership permissions to restore them."
      : '';

    const isSingleRestore = deleteItem?.length === 1;
    openInfoDialog({
      topIcon: <WarningContentInfoIcon />,
      title: isSingleRestore
        ? 'Are you sure you want to restore this model?'
        : 'Are you sure you want to restore these models?',
      description: `${
        isSingleRestore ? 'This model' : 'These models'
      } maybe linked to certain items (projects, props, renders etc.). Restoring it will allow you to use these items without any restrictions.`,
      secondLineDescription: message,
      cancelButtonText: 'Cancel',
      buttonText: 'Confirm',
      size: 'lg',
      titleStyle: { textAlign: 'start' },
      onButtonClick: async () => {
        const formData = new FormData();
        formData.append('is_delete_on_expire', false);
        formData.append('product_ids', deleteItem?.map(({ id }) => id)?.join(','));
        const res = await apiModelDeleteAndRestore(
          formData,
          `Your ${!isSingleRestore ? 'models' : 'model'} restored successfully`
        );
        if (res?.status) {
          refetchList?.();
        }
      },
      okBtnColor: null,
      cancelBtnColor: null,
      okBtnClassName: null,
    });
  };

  const deleteBtn = [
    {
      element: BigButton,
      bigBtnClass: 'lf-btn-2',
      variant: 'secondary',
      buttonTitle: 'Delete',
      iconBefore: <TrashV2Icon />,
      onClick: () =>
        isGuestUser()
          ? handleDeleteGuestUser(selectedList)
          : handleDelete(selectedList?.filter(({ is_delete_on_expire }) => !is_delete_on_expire)),
    },
  ];

  const modelsTopButtonsNewUser = [
    ...deleteBtn,
    {
      element: BigButton,
      bigBtnClass: 'lf-btn-2',
      variant: 'secondary',
      buttonTitle: 'Restore',
      iconBefore: <RestoreIcon />,
      onClick: () =>
        handleRestoreModal(selectedList?.filter(({ is_delete_on_expire }) => is_delete_on_expire)),
    },
  ];

  const handleFilterBtn = () => {
    const isDeletedRequest = selectedList?.some(({ is_delete_on_expire }) => !is_delete_on_expire);
    const isRestoredRequest = selectedList?.some(({ is_delete_on_expire }) => is_delete_on_expire);
    let newList = [];
    if (isRestoredRequest && isDeletedRequest) {
      newList.push(...modelsTopButtonsNewUser);
    }
    if (isDeletedRequest && !isRestoredRequest) {
      newList.push(...modelsTopButtonsNewUser.slice(0, 1));
    }
    if (isRestoredRequest && !isDeletedRequest) {
      newList.push(...modelsTopButtonsNewUser.slice(1));
    }
    newList.push(...topButtonList);
    return newList;
  };

  const topButtons = isModalPage && isFreemiumOrSelfServeUser ? handleFilterBtn() : topButtonList;
  return (
    <>
      {!useGlobalSearch && <Breadcrumbs fullWidth list={breadcrumbs} />}
      <CommonGrid
        item={title}
        noDataText={_noDataText}
        sticky={hideStickyHeader ? false : true}
        disableNoDataText={!loading && imageSearchFile}
        className={(anySelected || allSelected) && designV2 ? 'show-action-footer' : ''}
        {...(designV2
          ? {
              topContainer: (
                <TopContainerV2
                  subClassName={
                    modelType === MODEL_TYPES.THREEDMODELS
                      ? `smaller-width my3dmodel-topContainerV2 ${subClassName} myProductSection`
                      : `smaller-width myprop-topContainerV2 ${subClassName} myProductSection`
                  }
                  globalFilter={
                    !useGlobalSearch && (
                      <div>
                        <GlobalFilter designV2 />
                        <GlobalSearchTagsFilter designV2={designV2} />
                        <GlobalDefaultTeamMemberFilter designV2 />
                      </div>
                    )
                  }>
                  <>
                    {!useGlobalSearch && (
                      <>
                        <div className="totalCount">{totalItemCount(total)}</div>
                        <PageSearchBar
                          designV2
                          model={COMMON_TAGS_MODEL_TYPES.PRODUCT}
                          onSearchChange={onSearchChange}
                          search={search}
                          imageSearchActive={imageScanSearchOpen}
                          onImageSearchClick={toggleImageScanSearchOpen}
                        />
                        <FilterSideModalButton
                          disabled={imageSearchFile}
                          showTeamMemberFilter={showTeamMemberFilter}
                        />
                        <ActionFilters
                          loading={imageSearchFile || loading}
                          {...((modelType === MODEL_TYPES.PRODUCT ||
                            modelType === MODEL_TYPES.THREEDMODELS) && {
                            filterProps: {
                              value: filterBy,
                              data: isFreemiumOrSelfServeUser
                                ? FILTER_BY_DELETE_OPTIONS_LIST
                                : FILTER_BY_OPTIONS_LIST,
                              onChange: handleFilterByChange,
                              containerClass: 'top-filter',
                            },
                          })}
                          sortProps={
                            // (loading || list?.length > 0) &&
                            {
                              disabled: Boolean(search),
                              value: sortBy,
                              data: sortOptions,
                              onChange: onSortChange,
                              containerClass: 'top-filter',
                            }
                          }
                          showTeamMemberFilter={false}
                        />
                        {modelType === MODEL_TYPES.THREEDMODELS && !isGuestUser() ? (
                          <Upload3DModalButton onSuccess={refetchList} />
                        ) : null}
                      </>
                    )}
                  </>
                </TopContainerV2>
              ),
            }
          : {
              topContainer: (
                <TopContainer
                  title={
                    !useGlobalSearch && <PageTitle title={title} total={total} search={search} />
                  }
                  item={cardType}
                  hasData={hasData}
                  buttonArea={
                    <div style={{ display: 'flex' }}>
                      <TopButtonArea
                        hasData={hasData}
                        item={cardType}
                        topButtonList={isGuestUser() ? deleteBtn : topButtons}
                        anySelected={anySelected}
                        selectedList={selectedList}
                      />
                      {!useGlobalSearch && (
                        <FilterSideModalButton showTeamMemberFilter={showTeamMemberFilter} />
                      )}
                    </div>
                  }
                  searchBar={
                    !useGlobalSearch && (
                      <div className="mt-2">
                        <PageSearchBar
                          model={COMMON_TAGS_MODEL_TYPES.PRODUCT}
                          onSearchChange={onSearchChange}
                          search={search}
                        />
                      </div>
                    )
                  }
                />
              ),
            })}
        hasData={list.length > 0 || loading}
        list={list}
        {...(!designV2 &&
          !useGlobalSearch && {
            filterArea: (
              <>
                <ActionFilters
                  loading={imageSearchFile || loading}
                  sortProps={
                    // (loading || list?.length > 0) &&
                    {
                      value: sortBy,
                      data: sortOptions,
                      onChange: onSortChange,
                    }
                  }
                  selectedProps={
                    list?.length > 0 && {
                      allSelected: allSelected,
                      onSelectAll: () => toggleAll(),
                    }
                  }
                  showTeamMemberFilter={false}
                />
                <GlobalFilter />
              </>
            ),
          })}>
        {imageSearchFile ? (
          <div
            className="image-search-container"
            style={{
              height: height,
            }}>
            <SearchFromScannedImage
              refetchList={refetchList}
              loading={loading}
              onClose={refetchList}
            />
            <InfiniteScroll
              loadingType={null}
              dataLength={list.length}
              next={fetchMoreData}
              hasMore={hasMore}
              loading={loading}
              hasChildren={Boolean(list.length)}
              scrollableTarget="infiniteScroll">
              <ThumbnailContainerV2
                className={'gridV2'}
                designV2={designV2}
                items={list}
                modelType={modelType}
                // selected={selected}
                cardProps={{
                  fullWidth: true,
                  capitalize: false,
                  ...cardProps,
                }}
              />
              {!loading && list.length === 0 && (
                <div
                  className="d-flex justify-content-center align-items-center"
                  style={{ padding: '200px 0' }}>
                  <h1 className="noDataText">{_noDataText}</h1>
                </div>
              )}
              {hasMore && <div id="whiteShadow" />}
            </InfiniteScroll>
          </div>
        ) : (
          <InfiniteScroll
            dataLength={list.length}
            next={fetchMoreData}
            hasMore={hasMore}
            loading={loading}
            hasChildren={hasData}
            scrollableTarget="infiniteScroll">
            <ThumbnailContainerV2
              designV2={designV2}
              items={list}
              modelType={modelType}
              selected={selected}
              hideOrg={isGuestLogin}
              cardProps={{
                fullWidth: true,
                capitalize: false,
                onSelect: toggleItem,
                refetchList: refetchList,
                ...cardProps,
              }}
            />
            {hasMore && <div id="whiteShadow" />}
          </InfiniteScroll>
        )}

        {(anySelected || allSelected) && designV2 && (
          <FooterOptions>
            <>
              <div className="selected-item">
                <ActionFilters
                  selectedProps={
                    list?.length > 0 && {
                      allSelected: allSelected,
                      onSelectAll: () => toggleAll(),
                    }
                  }
                />
                <span>{selectedList?.length || 0} Selected</span>
              </div>
              <div className="footer-action">
                <TopButtonArea
                  hasData={hasData}
                  item={cardType}
                  topButtonList={
                    isGuestUser()
                      ? deleteBtn
                      : selectedList?.length && selectedList[0]?.is_archived
                      ? [
                          {
                            element: BigButton,
                            bigBtnClass: 'lf-btn-2',
                            iconBefore: <RestoreIcon />,
                            buttonTitle: 'Restore',
                            onClick: handleRestore,
                          },
                        ]
                      : topButtons
                  }
                  anySelected={anySelected}
                  selectedList={selectedList}
                />
              </div>
            </>
          </FooterOptions>
        )}

        <PropsEditDetailsPopupController onUpdateSuccess={handleProductUpdate} />

        <PropDetailsPopup redirect />
        {isGuestUser() ? null : (
          <My3dModelDetailsPopupController onUpdateSuccess={handleUpdateModelSuccess} />
        )}
        <AddToCollectionPopup onSuccess={resetSelection} />
        <ImageScanSearchModal />
      </CommonGrid>

      <GenerateContentModal refetchList={refetchList} isModel={true} />
      <ContentGeneration refetchList={refetchList} />
    </>
  );
}
